import { render, staticRenderFns } from "./RsaPazienteSocioRiabilitativoObiettiviDsmEditComponent.vue?vue&type=template&id=27e2f624"
import script from "./RsaPazienteSocioRiabilitativoObiettiviDsmEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazienteSocioRiabilitativoObiettiviDsmEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports